import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import logger from '../utils/logger';
import '../styles/components/layout.css';

const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      logger.auth('Iniciando logout a partir do Header');
      await signOut();
      navigate('/');
    } catch (error) {
      logger.error('Erro ao fazer logout:', error);
    }
  };
  
  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex-1"></div> {/* Espaçador esquerdo */}
        
        <div className="flex justify-center flex-1">
          <img 
            src="/assets/images/logo-2.png" 
            alt="Alexander Logo" 
            className="h-10" // Ajustando para um tamanho mais adequado
          />
        </div>
        
        <div className="flex-1 flex justify-end">
          {user && (
            <button
              onClick={handleLogout}
              className="px-4 py-2 text-sm font-medium text-white bg-accent hover:bg-accent-dark rounded-md transition-colors"
            >
              Sair
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
